export function Spinner({ label = "Загрузка…" }: { label?: string }) {
  return (
    <div className="flex flex-col items-center justify-center py-8 text-hint" role="status">
      <div className="h-8 w-8 animate-spin rounded-full border-2 border-hint border-t-transparent" />
      <span className="mt-2 text-sm">{label}</span>
    </div>
  );
}

export function Skeleton({ className }: { className?: string }) {
  return (
    <div
      className={`animate-pulse rounded-card bg-sbg ${className ?? "h-16 w-full"}`}
      aria-hidden="true"
    />
  );
}
